import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class CommentPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.commentRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.commentImport,
    );
    this.commentAutocomplete = permissionChecker.match(
      Permissions.values.commentAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.commentCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.commentEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.commentDestroy,
    );
  }
}
